import { FinancialServiceProviderAdapters } from '@seapoint/server/enums';
import { ComponentProps } from 'react';
import { Stack } from '../../../../design-system/stack/stack';
import { AccountMappingForm, ExternalBankAccount } from './account-mapping-form';

export type CreateAccountSelectOptionValue = 'create';

type AccountMappingModalContentProps = {
  xeroBankAccounts: ExternalBankAccount[];
} & Omit<ComponentProps<typeof AccountMappingForm>, 'xeroBankAccounts'>;

export const AccountMappingModalContent = ({
  accounts,
  xeroBankAccounts,
  ...rest
}: AccountMappingModalContentProps) => {
  const seapointAccounts = accounts.filter((account) => account.fspAdapter === FinancialServiceProviderAdapters.MODULR);
  const xeroBankAccountsWithCreateOption: ComponentProps<typeof AccountMappingForm>['xeroBankAccounts'] = [
    ...xeroBankAccounts.map((xeroBankAccount) => ({
      type: 'existing' as const,
      ...xeroBankAccount,
    })),
    { type: 'create', id: 'create', name: 'Create new account in Xero' },
  ];

  return (
    <Stack space={5} align="stretch" className="mx-auto mt-[100px] w-[950px]">
      <Stack space={2} align="stretch">
        <h1 className="text-xl font-medium leading-5 tracking-tight text-black">
          Select Xero accounts for each Seapoint account
        </h1>

        <p className="text-base font-normal leading-5 tracking-tight text-seapoint-gray">
          Map your Seapoint accounts to Xero and choose how far back you'd like us to sync your transactions. You can
          update these at any time from your settings.
        </p>
      </Stack>

      <AccountMappingForm accounts={seapointAccounts} xeroBankAccounts={xeroBankAccountsWithCreateOption} {...rest} />
    </Stack>
  );
};
